import { IOrder, Order } from "@/classes";
import axios from "axios";

export class OrderService {
  public async getAll(): Promise<Order[]> {
    const { data } = await axios.get<IOrder[]>("/api/orders");
    return data.map((x: any) => new Order(x));
  }

  public async getOne(id: number): Promise<Order> {
    const { data } = await axios.get<IOrder>(`/api/orders/${id}`);
    return new Order(data);
  }

  public async create(order: Order): Promise<Order> {
    const { data } = await axios.post<IOrder>(`/api/orders`, order);
    return new Order(data);
  }

  public async resubmit(order: Order): Promise<Order> {
    const { data } = await axios.get<IOrder>(
      `/api/orders/${order.id}/resubmit`
    );
    return new Order(data);
  }
}
